import { RJSFSchema } from "@rjsf/utils";
import type { JSONSchema7 } from "json-schema";

import { DrawGeometryType } from "../types/draw-geometry-form-data";

// Get accepted geometry types from schema
// Json typing is annoying here, so we have to do alot of type assertions
export const getAcceptedGeometryTypes = (schema: RJSFSchema): DrawGeometryType[] => {
  return Array.from(
    new Set(
      [schema, ...(schema.anyOf ?? []), ...(schema.oneOf ?? [])]
        .filter((s): s is JSONSchema7 => typeof s !== "boolean")
        .map((s) => s.properties?.type)
        .filter((s): s is JSONSchema7 => !!s && typeof s !== "boolean")
        .map((s) => s.const)
        .filter((s): s is DrawGeometryType => typeof s === "string")
    )
  );
};
